// 초기화
export const handleResetClick = (pagePath , setSearchConfirm ) => {
    setSearchConfirm(false);
    window.location.href = pagePath;
};